function optionValue(value, options) {
  if (value == null || value === "") return "";
  return options.find(option => String(option.value) === String(value))?.value ?? value;
}

export function partEditFields(part, userId, sideOptions, conditionOptions) {
  return {
    side: optionValue(part.side, sideOptions),
    part_number: part.part_number ?? "",
    condition_preference: optionValue(part.condition_preference, conditionOptions),
    quantity: part.quantity ?? 1,
  };
}

export function validatedPartEdit(fields) {
  const quantity = fields.quantity;
  if (quantity == null || String(quantity).trim() === "" || !Number.isSafeInteger(Number(quantity)) || Number(quantity) < 1) {
    throw new Error("Quantity must be a whole number of at least 1.");
  }
  return { ...fields, quantity: Number(quantity) };
}
